import { captureException } from "@sentry/react";
import { createParser, parseAsJson, parseAsString, useQueryStates } from "nuqs";
import type { ApiResponse } from "../components/contact-form/api/types";
import { apiResponseSchema } from "../components/contact-form/api/types";
import { existingPatientContactFormSchema } from "../components/contact-form/contactFormSchema";

const apiResponseParser = createParser({
  parse(value: string | null | undefined) {
    if (!value) return null;
    try {
      const parsed = JSON.parse(value);

      const parseResult = apiResponseSchema.safeParse(parsed);

      return parseResult.success ? parsed : null;
    } catch (error) {
      captureException(error);
      return null;
    }
  },
  serialize(value: ApiResponse | null) {
    return value ? JSON.stringify(value) : "";
  },
});

export function useQuestionnaireQueryStates() {
  return useQueryStates(
    {
      apiResponse: apiResponseParser,
      formData: parseAsJson(existingPatientContactFormSchema.parse).withDefault(
        {
          phone: "",
          phoneValid: false,
          country: "",
          zipCode: "",
          dateOfBirth: "",
          ethnicity: [],
          termsAccepted: false,
          thirdPartyContactConsentVersion: "",
          consentLocaleCode: "",
          trialSiteId: "",
          trialSiteTrialId: "",
        },
      ),
      priorityStudyId: parseAsString.withDefault(""),
    },
    {
      history: "push",
    },
  );
}
